import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import { environment } from '@env/environment';
import { BcmService } from '../../../bcm.service';

type LAST_INSERT_ID = number;
type EFFECTED_ROWS = number;

/**
 * ToDo: Should this API Services be placed in /modules/bcm/ ??
 */

@Injectable({
    providedIn: 'root'
})
export class BcmApiService extends BaseApiService {

    private _disableSyncForNextRequest = false;

    protected className = 'BcmApiService';

    protected endpoint = environment.endpoints.bcm.api;

    constructor(
        _http: HttpClient,
        protected bcmService: BcmService,
    ) {
        super(_http);
    }

    protected disableSyncForNextRequest(): void {
        this._disableSyncForNextRequest = true;
    }

    protected suppressErrorForNextRequest(): void {
        this._suppressErrorForNextRequest = true;
    }

    /** Optionaler GET — fehlende Rolle → 403 ohne globalen Toast (#7202). */
    protected optionalReadGet<T>(path: string, params: HttpParams = new HttpParams()): Observable<T> {
        // Ohne Sync fehlt die Tenant-ID oder sie ist veraltet.
        this._syncEndpoint();
        return super.getOptionalRead<T>(path, params);
    }

    // ToDo: make protected
    get<T>(path: string, params: HttpParams = new HttpParams()): Observable<T> {
        this._syncEndpoint();
        return super.get<T>(path, params);
    }

    // ToDo: make protected
    getBlob(path: string, params: HttpParams = new HttpParams()): Observable<any> {
        this._syncEndpoint();
        return super.getBlob(path, params);
    }

    // ToDo: make protected
    getBlobWithProgress(path: string, params: HttpParams = new HttpParams()): Observable<any> {
        this._syncEndpoint();
        return super.getBlobWithProgress(path, params);
    }

    // ToDo: make protected
    post<T = LAST_INSERT_ID>(path: string, body: object = {}, params: HttpParams = new HttpParams()): Observable<T> {
        this._syncEndpoint();
        return super.post<T>(path, body, params);
    }

    // ToDo: make protected
    postWithBlobResponse<T = LAST_INSERT_ID>(path: string, body: object = {}, params: HttpParams = new HttpParams()): Observable<T> {
        this._syncEndpoint();
        return super.postWithBlobResponse<T>(path, body, params);
    }

    // ToDo: make protected
    put<T = EFFECTED_ROWS>(path: string, body: object = {}, params: HttpParams = new HttpParams()): Observable<T> {
        this._syncEndpoint();
        return super.put<T>(path, body, params);
    }

    // ToDo: make protected
    delete<T = EFFECTED_ROWS>(path, params: HttpParams = new HttpParams(), body?: unknown): Observable<T> {
        this._syncEndpoint();
        return super.delete<T>(path, params, body);
    }

    private _syncEndpoint(): void {
        if (!this._disableSyncForNextRequest && this.bcmService.tenant) {
            this.endpoint = `${environment.endpoints.bcm.api}${this.bcmService.tenant.id}/`;
        } else {
            this.endpoint = environment.endpoints.bcm.api;
        }

        this._disableSyncForNextRequest = false;
    }
}
